import Vue from 'vue'

export const dashboardStore = {
  state: {
    resident: {},
    dorm: {},
    room: {},
    errors: {}
  },
  mutations: {
    setResident(state, resident) {
      Vue.set(state, 'resident', resident)
    },
    setDorm(state, dorm) {
      Vue.set(state, 'dorm', dorm)
    },
    setRoom(state, room) {
      Vue.set(state, 'room', room)
    }
  },
  actions: {
    clearResident({ commit }) {
      commit('setResident', {})
    },
    clearDorm({ commit }) {
      commit('setDorm', {})
    },
    clearRoom({ commit }) {
      commit('setRoom', {})
    },
    getData({ commit, state }) {
      return new Promise((resolve, reject) => {
        Vue.http.get(`api/v1/residents`).then(data => {
          if (data.ok) {
            commit('setResident', data.body.resident)
            commit('setDorm', data.body.dorm)
            commit('setRoom', data.body.room)
          }
        })
      })
    }
  }
}
